export const textChars = (e) => {
  const regex = /[a-zA-Z\s]/g;
  if (!regex.test(e.key)) {
    e.preventDefault();
  }
};

export const numberChars = (e) => {
  const regex = /[\d]/g;
  if (!regex.test(e.key)) {
    e.preventDefault();
  }
};

export const alphanumericChars = (e) => {
  const regex = /[0-9a-zA-Z-\s]/g;
  if (!regex.test(e.key)) {
    e.preventDefault();
  }
};

export const emailChars = (e) => {
  const regex = /[a-z0-9_+@.-]/g;
  if (!regex.test(e.key)) {
    e.preventDefault();
  }
};

export const passwordChars = (e) => {
  const regex = /[.*]/g;
  if (!regex.test(e.key)) {
    e.preventDefault();
  }
};
